/**
 * Shared shadcn-style theme for Summary / CSPM + FinOps dashboards.
 * Uses Inter font and zinc/slate palette.
 */
export const summaryTheme = {
  fontFamily: '"Inter", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  colors: {
    background: "#fafafa",
    card: "#ffffff",
    border: "#e4e4e7",
    borderLight: "#f4f4f5",
    text: "#18181b",
    textMuted: "#71717a",
    textMutedLight: "#a1a1aa",
    primary: "#18181b",
    primaryHover: "#27272a",
    accent: "#3b82f6",
    accentHover: "#2563eb",
    destructive: "#dc2626",
    destructiveBg: "#fef2f2",
    destructiveBorder: "#fecaca",
    success: "#16a34a",
    successBg: "#f0fdf4",
    warning: "#d97706",
    warningBg: "#fffbeb",
    severity: {
      critical: "#b91c1c",
      high: "#dc2626",
      medium: "#d97706",
      low: "#64748b",
    },
  },
  radius: {
    sm: "6px",
    md: "8px",
    lg: "12px",
    xl: "16px",
  },
  shadow: "0 1px 3px 0 rgba(0,0,0,0.05), 0 1px 2px -1px rgba(0,0,0,0.05)",
};
